

































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {Meta} from '@sophosoft/vue-meta-decorator'

import {TableItem, TableHeaderItem} from '@/utils/types'

import {Profile, Company, Contact, Badge} from '@/store/modules/lib'

import ContactList from '@/components/lfs/Company/ContactList.vue'
import BadgeEditModal from '@/components/lfs/Badges/BadgeEditModal.vue'
import VueQrcode from 'vue-qrcode'
import ContactModal from '@/components/lfs/Company/CompanyEditModal.vue'
import axios from 'axios';
import {SERVER_HOST_QR} from '@/config';
import Search from "@/components/UI/Search.vue";
import IClose from '@/components/icons/IClose.vue'
import Modal from "@/components/UI/Modal.vue";

interface IStandLink {
  title: string
  link: string
}

const profile = namespace('profile')
const event = namespace('event')
const roistat = namespace('roistat')

@Component({
  components: {
    'vue-qr-code': VueQrcode,
    ContactList,
    'c-badge-edit-modal': BadgeEditModal,
    'c-contact-modal': ContactModal,
    Search,
    'i-close': IClose,
    Modal,
  }
})
export default class Standmans extends Vue {

  // disableButton:boolean = true

  async addNewStandman() {
    this.addStandmanDlgState = false
    const params =
      {
        "name": {
          first: this.firstName.trim(),
          last: this.lastName.trim()
        },
        /*"position": this.position*/
      }

    try {
      const {data} = await axios.post(SERVER_HOST_QR + 'show/' + this.shows[0].code + '/company/stand-man', params)
      if (data.status && data.status === 'err') {
        throw data
      }


      let standMan: any = data.data
      console.log(standMan)
      standMan.metadata = {}
      standMan.metadata.createAt = data.data.createAt
      console.log(standMan)

      this.addStandMans(standMan)
      this.clearAddStandManForm()

    } catch (error) {
      if (error.response && error.response.data) {
        this.errorText = error.response.data.error
      } else {
        console.log(error)
      }

    }


  }

  clearAddStandManForm() {
    this.addStandmanDlgState = false
    this.firstName = ''
    this.lastName = ''
  }

  errorText: string = ''

  firstName: string = ''
  lastName: string = ''
  position: string = ''
  search: string = ''

  deleteDlgState: boolean = false

  @profile.Action('deleteBadge') protected deleteBadge: any
  @event.Getter('shows') protected shows: any
  @roistat.Action('sendEvent') protected sendEvent: any

  async deleteStandist() {
    await this.deleteBadge(this.currentBadge.id)
    this.deleteDlgState = false
    let params = [
      {
        "name": "“Стендисты”: Действие “Удаление бейджа”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  @Meta
  getMetaInfo() {
    return {
      title: `LeadFrog - Стендисты`,
    }
  }

  protected dlgTitleBarcode: string = ''
  protected dlgCode: string = ''
  protected barcodeDlgState: boolean = false

  protected openBarcodeDlg(item: TableItem): void {
    this.dlgTitleBarcode = `${item.first} ${item.last}`
    this.dlgCode = item.barcode
    this.barcodeDlgState = true
  }

  @profile.State('userCompany') protected userCompany: any
  @profile.Mutation('addStandMans') protected addStandMans: any
  @profile.Mutation('setProfile') protected setProfile: any
  @profile.State('profiles') protected badges: any
  @profile.State('standCompanies') protected standCompanies!: Company[]

  protected helpDlg: boolean = false

  protected applyHelp(): void {
    localStorage.setItem('profile-help-close', '1')

    this.helpDlg = false
  }

  protected editBadgeDlgState: boolean = false
  protected editContactDlgState: boolean = false
  protected currentBadge: any = {}

  @Watch('currentBadge')
  isCurrentBadgeEdit(newValue: Badge): void {
    const links = newValue.promo
    const badgeId = newValue.id

    this.$store.commit('profile/setBadgeLinks', {
      badgeId,
      links
    })
  }

  protected get standLinks(): IStandLink[] {
    return this.standCompanies.map((company: Company) => {
      return {
        title: company.standTitle,
        link: `https://lfqr.cc/e/${company._show}/s/${company.standTitle}`
      }
    })
  }

  protected get profileCompany(): Company {
    return this.$store.getters['profile/userCompany']
  }

  protected get items(): TableItem[] {
    return this.badges.map((badge: Profile) => {
      return {
        id: badge._id,
        barcode: badge.barcode,
        first: badge.name.first,
        last: badge.name.last,
        position: badge.position,
        about: badge.about,
        contacts: badge.contacts,
        locations: badge.locations,
        promo: badge.promo,
        createAt: badge.metadata.createAt
      }
    })
  }

  protected getCompanyContact(type: string) {
    if (this.userCompany != null) {
      let contact = this.userCompany.contacts.filter(
        (contact: Contact) => contact.type === type
      )

      if (contact.length > 0) return contact[0].value
    }

    return ''
  }

  get headers() {
    return [
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'barcode',
        width: '70',
        type: 'barcode',
        action: 'openBarcodeDlg'
      },
      {text: this.$t('profile.standman.name'), value: 'first', sortable: false, width: '144'},
      {text: this.$t('profile.standman.last_name'), value: 'last', sortable: false, width: '246'},
      {text: this.$t('profile.standman.position'), value: 'position', sortable: false,},
      {text: '', align: 'end', value: 'edit', sortable: false, width: '30', type: 'icon', action: 'openDlgEditProfile'},
      {text: '', align: 'end', value: 'delete', sortable: false, width: '30', type: 'icon', action: 'openDelete'},
    ]
  }

  protected mounted(): void {
    if (!localStorage.getItem('profile-help-close')) {
      this.helpDlg = true
    }
  }

  get itemsSearch() {
    if (this.search === '') return this.items.sort((a: any, b: any) => {
      return b.createAt - a.createAt
    })
    return this.items
      .filter((el: any) => {
        return el.first.toLowerCase().includes(this.search.toLocaleLowerCase()) || el.last.toLowerCase().includes(this.search.toLocaleLowerCase()) || el.position.toLowerCase().includes(this.search.toLocaleLowerCase())
      })
      .sort((a: any, b: any) => {
        return b.createAt - a.createAt
      })
  }

  openDlgEditProfile(item: any): void {
    this.currentBadge = item
    this.setProfile(item.id)
    this.editBadgeDlgState = true
  }

  onChange(val: any): void {
    this.currentBadge = {...this.currentBadge, ...val}
  }

  onChangeLocations(val: any): void {
    this.currentBadge.locations = val
  }

  onDelete(val: any): void {
    this.currentBadge = val
  }

  protected addStandmanDlgState: boolean = false

  openDlgNewStandman() {
    this.addStandmanDlgState = true
  }

  addStandmanDlgClose() {
    this.addStandmanDlgState = false
    this.firstName = ''
    this.lastName = ''
  }

  openDelete(item: any) {
    this.deleteDlgState = true;
    this.currentBadge = item
  }
}
